import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/revenue-lockdowns/profile/loading';

export const Route = createFileRoute('/_private/settings/revenue-lockdowns/$id')({
  pendingComponent: Loading,
});
